import { fetchMembers } from "../../utils/dataLoader";
import { getMembersByCountry, calculateGeoBounds, calculateCenterAndZoom } from "../../utils/countryHelpers";

// Map country codes from JSON to react-simple-maps country IDs
const COUNTRY_CODE_MAP = {
  'ITA': '380', // Italy
  'LAO': '418', // Lao PDR
  'MNG': '496', // Mongolia
  'JPN': '392', // Japan
  'MYS': '458', // Malaysia
};

const WorldMapHandler = (stateWorldMap, setWorldMap) => {
  // Helper to fit map to highlighted countries
  const fitToHighlightedCountries = () => {
    if (stateWorldMap.geographies.length === 0 || stateWorldMap.highlightedCountries.length === 0) {
      return;
    }

    const bounds = calculateGeoBounds(stateWorldMap.geographies, stateWorldMap.highlightedCountries);
    if (bounds) {
      const { center, zoom } = calculateCenterAndZoom(bounds);
      setWorldMap({
        mapCenter: center,
        mapZoom: zoom,
      });
    }
  };

  return {
    handleLoadMembers: async () => {
      try {
        setWorldMap("loading", true);
        setWorldMap("error", null);

        const membersData = await fetchMembers();
        
        // Map country codes to react-simple-maps IDs
        const highlightedIds = membersData
          .map(member => COUNTRY_CODE_MAP[member.countryCode])
          .filter(id => id); // Remove undefined values

        setWorldMap({
          members: membersData,
          highlightedCountries: highlightedIds,
          loading: false,
        });

        // Auto-fit to highlighted countries will happen in handleGeographiesLoad
      } catch (error) {
        console.error("Error loading members:", error);
        setWorldMap({
          error: "Failed to load member data. Please try again.",
          loading: false,
        });
      }
    },

    handleGeographiesLoad: (geographies) => {
      setWorldMap("geographies", geographies);
      
      // Auto-fit to highlighted countries once geographies are loaded
      if (stateWorldMap.highlightedCountries.length > 0) {
        const bounds = calculateGeoBounds(geographies, stateWorldMap.highlightedCountries);
        if (bounds) {
          const { center, zoom } = calculateCenterAndZoom(bounds);
          setWorldMap({
            mapCenter: center,
            mapZoom: zoom,
          });
        }
      }
    },

    handleFitToHighlighted: () => {
      fitToHighlightedCountries();
    },

    handleZoomIn: () => {
      setWorldMap("mapZoom", Math.min(stateWorldMap.mapZoom + 0.5, 8));
    },

    handleZoomOut: () => {
      setWorldMap("mapZoom", Math.max(stateWorldMap.mapZoom - 0.5, 1));
    },

    handleCenterChange: (newCenter) => {
      setWorldMap("mapCenter", newCenter);
    },

    handleZoomChange: (newZoom) => {
      setWorldMap("mapZoom", newZoom);
    },

    handleCountryClick: (country) => {
      if (!country) return;

      // Find members for this country by mapping the country ID back to our code
      const countryCodeEntry = Object.entries(COUNTRY_CODE_MAP).find(
        ([code, id]) => id === country.id
      );

      if (!countryCodeEntry) {
        console.log("No members in this country");
        return;
      }

      const [countryCode] = countryCodeEntry;
      const members = getMembersByCountry(stateWorldMap.members, countryCode);

      if (members.length > 0) {
        setWorldMap({
          selectedCountry: country.id,
          selectedCountryName: country.name,
          selectedMembers: members,
          isModalOpen: true,
        });
      }
    },

    handleCountryHover: (country) => {
      setWorldMap("hoveredCountry", country);
    },

    handleModalClose: () => {
      setWorldMap({
        isModalOpen: false,
        selectedCountry: null,
        selectedCountryName: null,
        selectedMembers: [],
      });
    },
  };
};

export default WorldMapHandler;
